import { createSelector } from "reselect";
import { DateHelper } from "shared/helpers/DateHelper";

const getPlanItems = (state) => state.items;
const getToday = (state) => state.today;

export const getActItems = createSelector(
  [getPlanItems, getToday],
  (planItems, today) => {
    return filterActItems(planItems, today);
  }
);

function filterActItems(items, today) {
  const dateHelper = new DateHelper(today);
  const todayString = dateHelper.getDateString();
  let prevDay = null;
  let isLeading;
  const filteredItems = [];
  items.forEach((item) => {
    if (isActionable(item, todayString, dateHelper)) {
      isLeading = item.day !== todayString && prevDay !== item.day;
      filteredItems.push({ ...item, isLeading: isLeading });
      prevDay = item.day;
    }
  });
  let aheadIndex = filteredItems.findIndex((item) => item.day !== todayString);
  if (aheadIndex === -1) {
    aheadIndex = filteredItems.length;
  }
  filteredItems.splice(aheadIndex, 0, {
    type: "day_name",
    day_name: "Ahead",
    day: dateHelper.tomorrowDateString(),
  });
  return filteredItems;
}

function isActionable(item, todayString, dateHelper) {
  return (
    item.type === "new_task" ||
    (item.type === "task" &&
      item.day !== dateHelper.somedayDateString &&
      (item.day === todayString ||
        !item.active_date ||
        item.active_date === todayString ||
        dateHelper.parseDate(item.active_date).getTime() <
          dateHelper.date.getTime())) ||
    (item.type === "appointment" && item.day === todayString)
  );
}
